import { queryOptions } from "@tanstack/react-query";
import { apiGET } from "~/app/api/apiCallsService";
import { occUrl } from "~/app/api/occ/occFetch";

/** Session-derived order-type context shared by cart and checkout consumers. */
export interface CartOrderContext {
  selectedOrderType: string;
  availableOrderTypes?: string[];
}

async function fetchCartOrderContext(): Promise<CartOrderContext> {
  const response = await apiGET(occUrl("/cart-order-context"), {
    headers: { Accept: "application/json", "Content-Type": "application/json" },
  });
  if (!response.ok) {
    throw new Error(`Failed to load cart order context: ${response.status}`);
  }
  return response.json() as Promise<CartOrderContext>;
}

export const cartOrderContextQueryOptions = () =>
  queryOptions({
    queryKey: ["cart-order-context"],
    queryFn: fetchCartOrderContext,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
